module.exports = __webpack_public_path__ + "ggvue/img/hangye.13a81992.png";